export const basemapCollection = [
  {
    name: 'hybrid',
    label: 'Satellite',
  },
  {
    name: 'streets-navigation-vector',
    label: 'Light',
  },
  {
    name: 'streets-night-vector',
    label: 'Dark',
  },
  {
    name: 'osm',
    label: 'OSM',
  },
];
